import { reactive, ref } from "vue"


export const _G = {
    csrfName: "",
    csrfHash: "",
    token: "",

    ajaxBaseUrl: {
        "default": `http://localhost:8000`,
    },

    ajaxHeaders: reactive({}),

    mediaURL: `http://localhost:8000/media/`,

    main_host: 'example.com',

    defaultSelectedMenu: "index",

    defaultPage: "pages/Profile",

    projectName: "example.com",
    footerPowered: '<a href="https://example.com" class="footerClass" target="_blank">Organization Name</a> © 2024',
    footerDescription: 'Footer Description',

    ignored_routes: [
        "notfound_full",
        "notfound",
        "notperm",
        "profile",
        "404",
        "about",
    ],

    currentRoute: "",
    current: reactive({
        page: "",
        data: {}
    }),
    columnMaxConstraints: 3,

    rowsPerPage: 10,
    rowsPerPageOptions: [5, 10, 25, 50, 100, 500],

    uploadedFileSize: 52428800,

    showFilterAfterLength: 15,

    toastLifeTime: 2000,

    lang: ref({}),

    userImage: ref(''),

    systemData: reactive({}),

    toast: reactive({
        ref: null,
        class: {
            success: 'fas fa-check',
            error: 'fas fa-ban',
            info: 'fas fa-info-circle',
            warn: 'fas fa-exclamation-triangle',
        },
        obj: {},
        init: (opt) => {
            _G.toast.obj = {
                clean: (opt.clean !== undefined ? opt.clean : true),
                severity: _G.toast.obj.severity !== undefined ? _G.toast.obj.severity : 'success',
                position: opt.position !== undefined ? opt.position : 'center',
                msg: opt.msg !== undefined ? opt.msg : '',
                title: opt.title !== undefined ? opt.title : '',
                life: (opt.type === 'confirm') ? 0 : (opt.life !== undefined ? opt.life : _G.toastLifeTime),
                type: opt.type !== undefined ? opt.type : 'message',
                group: opt.group !== undefined ? opt.group : 'mainToast',

                yesButtonClass: opt.yesButtonClass !== undefined ? opt.yesButtonClass : undefined,
                yesIcon: opt.yesIcon !== undefined ? opt.yesIcon : undefined,
                yesTitle: opt.yesTitle !== undefined ? opt.yesTitle : 'yes',
                yes: opt.yes !== undefined ? opt.yes : () => { },
                noButtonClass: opt.noButtonClass !== undefined ? opt.noButtonClass : undefined,
                noIcon: opt.noIcon !== undefined ? opt.noIcon : undefined,
                noTitle: opt.noTitle !== undefined ? opt.noTitle : 'no',
                no: opt.no !== undefined ? opt.no : () => { _G.toast.ref.removeGroup('mainToast'); },
            };
            _G.toast.obj.icon = opt.icon !== undefined ? opt.icon : _G.toast.class[_G.toast.obj.severity];
        },
        notify: (opt) => {
            if (opt instanceof Object === false) {
                _G.toast.init({ msg: opt });
                _G.toast.obj.msg = opt;
            }
            else {
                _G.toast.init(opt);
            }

            if (_G.toast.obj.severity == 'success'){
                _G.toast.obj.position = 'bottom-center';
                // _G.toast.obj.position = 'center';
            }
            else{
                _G.toast.obj.position = 'center';
            }

            if (_G.toast.obj.type != 'confirm' || _G.toast.obj.clean){
                Array.from(document.getElementsByClassName('p-toast')).forEach((e) => {
                    e.style.bottom = '';
                });

                _G.toast.ref.removeGroup('mainToast');
            }

            return _G.toast.ref.add({
                severity: _G.toast.obj.severity,
                type: _G.toast.obj.type,
                icon: _G.toast.obj.icon,
                title: _G.toast.obj.title,
                detail: _G.toast.obj.msg,
                life: _G.toast.obj.life,
                group: _G.toast.obj.group,

                yesButtonClass: _G.toast.obj.yesButtonClass,
                yesIcon: _G.toast.obj.yesIcon,
                yesTitle: _G.toast.obj.yesTitle,
                yes: (e) => { _G.toast.obj.yes(e); _G.toast.ref.removeGroup('mainToast'); },
                noButtonClass: _G.toast.obj.noButtonClass,
                noIcon: _G.toast.obj.noIcon,
                noTitle: _G.toast.obj.noTitle,
                no: (e) => { _G.toast.obj.no(e); _G.toast.ref.removeGroup('mainToast'); },
            });
        },
        success: (opt) => {
            _G.toast.obj.severity = 'success';
            return _G.toast.notify(opt);
        },
        error: (opt) => {
            _G.toast.obj.severity = 'error';
            return _G.toast.notify(opt);
        },
        info: (opt) => {
            _G.toast.obj.severity = 'info';
            return _G.toast.notify(opt);
        },
        warn: (opt) => {
            _G.toast.obj.severity = 'warn';
            return _G.toast.notify(opt);
        },
    }),

    atoast: {
        ref: null,
        class: {
            success: 'fas fa-check',
            error: 'fas fa-ban',
            info: 'fas fa-info-circle',
            warn: 'fas fa-exclamation-triangle',
        },
        obj: {},
        init: (opt) => {
            _G.atoast.obj = {
                // clean: (opt.clean !== undefined ? opt.clean : true),
                // severity: _G.atoast.obj.severity || 'success',
                // position: opt.position || 'center',
                // msg: opt.msg || '',
                // title: opt.title || '',
                // life: (opt.type === 'confirm') ? 0 : (opt.life || _G.toastLifeTime),
                // type: opt.type || 'message',
                // group: opt.group || 'appToast',

                // yesTitle: opt.yesTitle || 'yes',
                // yes: opt.yes !== undefined ? opt.yes : (e) => { },
                // noTitle: opt.noTitle || 'no',
                // no: opt.no !== undefined ? opt.no : (e) => { _G.atoast.ref.removeGroup('appToast'); },

                // icon: (opt.icon !== undefined ? opt.icon : {
                //     success: 'fas fa-check',
                //     error: 'fas fa-ban',
                //     info: 'fas fa-info-circle',
                //     warn: 'fas fa-exclamation-triangle',
                // }),
                clean: (opt.clean !== undefined ? opt.clean : true),
                severity: _G.atoast.obj.severity !== undefined ? _G.atoast.obj.severity : 'success',
                position: opt.position !== undefined ? opt.position : 'center',
                msg: opt.msg !== undefined ? opt.msg : '',
                title: opt.title !== undefined ? opt.title : '',
                life: (opt.type === 'confirm') ? 0 : (opt.life !== undefined ? opt.life : _G.toastLifeTime),
                type: opt.type !== undefined ? opt.type : 'message',
                group: opt.group !== undefined ? opt.group : 'appToast',

                yesButtonClass: opt.yesButtonClass !== undefined ? opt.yesButtonClass : undefined,
                yesIcon: opt.yesIcon !== undefined ? opt.yesIcon : undefined,
                yesTitle: opt.yesTitle !== undefined ? opt.yesTitle : 'yes',
                yes: opt.yes !== undefined ? opt.yes : () => { },
                noButtonClass: opt.noButtonClass !== undefined ? opt.noButtonClass : undefined,
                noIcon: opt.noIcon !== undefined ? opt.noIcon : undefined,
                noTitle: opt.noTitle !== undefined ? opt.noTitle : 'no',
                no: opt.no !== undefined ? opt.no : () => { _G.atoast.ref.removeGroup('appToast'); },
            };
            _G.atoast.obj.icon = opt.icon !== undefined ? opt.icon : _G.atoast.class[_G.atoast.obj.severity];
        },
        notify: (opt) => {
            if (opt instanceof Object === false) {
                _G.atoast.init({ msg: opt });
                _G.atoast.obj.msg = opt;
            }
            else{
                _G.atoast.init(opt);
            }

            if (_G.atoast.obj.clean){
                _G.atoast.ref.removeAllGroups();//('appToast');
            }

            return _G.atoast.ref.add({
                severity: _G.atoast.obj.severity,
                icon: _G.atoast.obj.icon,
                type: _G.atoast.obj.type,
                title: _G.atoast.obj.title,
                detail: _G.atoast.obj.msg,
                life: _G.atoast.obj.life,
                group: _G.atoast.obj.group,

                yesButtonClass: _G.atoast.obj.yesButtonClass,
                yesIcon: _G.atoast.obj.yesIcon,
                yesTitle: _G.atoast.obj.yesTitle,
                yes: (e) => { _G.atoast.obj.yes(e); _G.atoast.ref.removeGroup('appToast'); },
                noButtonClass: _G.atoast.obj.noButtonClass,
                noIcon: _G.atoast.obj.noIcon,
                noTitle: _G.atoast.obj.noTitle,
                no: (e) => { _G.atoast.obj.no(e); _G.atoast.ref.removeGroup('appToast'); },
            });
        },
        success: (opt) => {
            _G.atoast.obj.severity = 'success';
            return _G.atoast.notify(opt);
        },
        error: (opt) => {
            _G.atoast.obj.severity = 'error';
            return _G.atoast.notify(opt);
        },
        info: (opt) => {
            _G.atoast.obj.severity = 'info';
            return _G.atoast.notify(opt);
        },
        warn: (opt) => {
            _G.atoast.obj.severity = 'warn';
            return _G.atoast.notify(opt);
        },
    },

    sortDictList: (arr, key, orderby) => {
        orderby = orderby === undefined ? 'asc' : orderby;
        arr = arr === undefined ? [] : arr;
        key = key === undefined ? 'length' : key;

        return orderby == 'desc' ? arr.sort((a, b) => {
            if (a[key] > b[key]) {
                return -1;
            }
            if (a[key] < b[key]) {
                return 1;
            }
            return 0;
        }) : arr.sort((a, b) => {
            if (a[key] < b[key]) {
                return -1;
            }
            if (a[key] > b[key]) {
                return 1;
            }
            return 0;
        });
    },

    sortList: (arr, orderby) => {
        orderby = orderby === undefined ? 'asc' : orderby;
        arr = arr === undefined ? [] : arr;

        return orderby == 'desc' ? arr.sort((a, b) => b - a) : arr.sort((a, b) => a - b);
    },

    uniqueId: (symlen) => {
        symlen = symlen ? symlen : 4;
        // if( arguments.length && arguments[0] ) symlen = arguments[0];
        // else symlen = 4;
        var symsize, pos, id = '', sym = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        symsize = sym.length;
        for (var i = 1; i <= symlen; i++) {
            pos = Math.floor(Math.random() * symsize);
            id += sym[pos];
        }
        return id;
    },

    modalFormValidate: (frm) => {
        let a = frm.currentTarget.closest('.dynamicModal').querySelector('form').querySelectorAll('.required');
        a.forEach((b) => {
            if (b.value == '') {
                b.classList.add('required');
            }
        });
    },

    isFormValid: (fdata) => {
        let validated = true;
        fdata.table_columns.forEach((b) => {
            if (b.required !== undefined && b.required && (fdata[b.name] === undefined || fdata[b.name] == '')) {
                validated = false;
            }
        });
        return validated;
    },

    // capitalize: (txt) => {
    //     return txt
    //         .trim()
    //         .toLowerCase()
    //         .replace(/\w\S*/g, (w) => w.replace(/^\w/, (c) => c.toUpperCase()));
    // },

    capitalize: str => str.charAt(0).toUpperCase() + str.slice(1),

    stripTags: str => str != '' ? str.replace(/(<[^>]*>)*/gm, '') : '',

    strip: (str, sym) => str != '' ? str.replace(new RegExp(`^${sym}+`, 'i'), '').replace(new RegExp(`${sym}+$`, 'i'), '') : '',

    token_data: () => {
        if (_G.hasClientData("AUTH_TOKEN"))
            return JSON.parse(atob(_G.getClientData('AUTH_TOKEN').split('.')[0]));
        else
            return {};
    },

    getByWordCount: (text, count) => {
        count = count !== undefined && count > 0 ? count : 12;
        let b = '';
        if(text.length){
            let a = text.split(' ');
            if(a.length > count) b = a.filter((e, i) => i < count).join(' ') + ' ...';
            else b = text;
        }
        return  b.length ? b : '';
    },

    formatLocale: (value) => {
        if (value)
            return value.toLocaleString("az-AZ", {
                style: "currency",
                currency: "AZN",
                hour12: false,
                hourCycle: 'h24',
                // weekday: 'long',
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
            });
        else
            return value;
    },

    formatDateLocale: (value) => {
        if (value)
            return value.toLocaleDateString("az-AZ", {
                // style: "currency",
                // currency: "AZN",
                hour12: false,
                hourCycle: 'h24',
                // weekday: 'long',
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
            });
        else
            return value;
    },

    returnLocaleDate: (datestr, separator = '.') => {
        let ds = datestr.split(separator);

        let yearlit = {
            "00": "cü",
            "10": "cu",
            "20": "ci",
            "30": "cu",
            "40": "cı",
            "50": "ci",
            "60": "cı",
            "70": "ci",
            "80": "ci",
            "90": "cı",
        };


        let daylit = {
            "1": "ci",
            "2": "ci",
            "3": "cü",
            "4": "cü",
            "5": "ci",
            "6": "cı",
            "7": "ci",
            "8": "ci",
            "9": "cu",
            // "0": "cu",
        };
        let dayadvlit = {
            "10": "da",
            "20": "də",
            "30": "da",
        };
        // let day = str(int(datestr.strftime("%d")));
        let day = parseInt(ds[0]).toString();

        let monlit = {
            "1": "yanvar",
            "2": "fevral",
            "3": "mart",
            "4": "aprel",
            "5": "may",
            "6": "iyun",
            "7": "iyul",
            "8": "avqust",
            "9": "sentyabr",
            "10": "oktyabr",
            "11": "noyabr",
            "12": "dekabr",
        };

        let monadvlit = {
            "1": "ın",
            "2": "ın",
            "3": "ın",
            "4": "in",
            "5": "ın",
            "6": "un",
            "7": "un",
            "8": "un",
            "9": "ın",
            "10": "ın",
            "11": "ın",
            "12": "ın",
        };

        let month = parseInt(ds[1]).toString();
        let year = ds[2];

        // let lit = daylit[year[-1]] if year[-1] != '0' else yearlit['60']
        let lit = '';
        if( year.slice(-1) != '0')
            lit = daylit[year.slice(-1)];
        else
            lit = yearlit[year.slice(-2)];

        // return f'{year}-{lit} il {monlit[month]}ın {day}-' + ('da' if day[-1] in ['6','9'] else 'də')
        return `${year}-${lit} il ${monlit[month]}${monadvlit[month]} ${day}-` + ( dayadvlit[day.slice(-2)] !== undefined ? dayadvlit[day.slice(-2)] : (['6','9'].indexOf(day.slice(-1)) != -1 ? 'da' : 'də') )
    },

    parseDateAsObject: (diff) => {
        var milliseconds,seconds,minutes,hours,days,months,years;

        diff=(diff-(milliseconds=diff%1000))/1000;
        diff=(diff-(seconds=diff%60))/60;
        diff=(diff-(minutes=diff%60))/60;
        diff=(diff-(hours=diff%24))/24;
        diff=(diff-(days=diff%30))/30;
        years=(diff-(months=diff%12))/12;

        return [years, months, days, hours, minutes, seconds, milliseconds];
    },

    parseDateAsCount: (diff) => {
        var milliseconds,seconds,minutes,hours,days,months,years;

        milliseconds = diff%1000;
        seconds = Math.floor(diff/1000);
        minutes = Math.floor(diff/(1000*60));
        hours = Math.floor(diff/(1000*60*60));
        days = Math.floor(diff/(1000*60*60*24));
        months = Math.floor(diff/(1000*60*60*24*30));
        years = Math.floor(diff/(1000*60*60*24*30*12));

        return [years, months, days, hours, minutes, seconds, milliseconds];
        // return {
        //     'years': years,
        //     'months': months,
        //     'days': days,
        //     'hours': hours,
        //     'minutes': minutes,
        //     'seconds': seconds,
        //     'milliseconds': milliseconds,
        // };
    },

    calcDateFormat: (diff, ff, type) => {
        var years, months, days, hours, minutes, seconds, milliseconds;
        if( type == 'object' )
            [years, months, days, hours, minutes, seconds, milliseconds] = _G.parseDateAsObject(diff);
        else
            [years, months, days, hours, minutes, seconds, milliseconds] = _G.parseDateAsCount(diff);

        let f1 = {
            'yy': years,
            'MM': months,
            'dd': days,
            'hh': hours,
            'mm': minutes,
            'ss': seconds,
            'ms': milliseconds,
        };

        for(let a in ff){
            ff[a] = f1[a] != undefined ? ff[a].replace(/%s/i, '').replace(/%d/i, `${f1[a]}`) : ff[a].replace(/%s/i, '');
            // ff[a] = f1[a] != undefined ? ff[a].replace(/%s/i, '').replace(/%d([^>]*)/i, `${f1[a]}[$1]`) : ff[a];
        }
        return [ff, years, months, days, hours, minutes, seconds, milliseconds];
    },

    formatDateDuration: (opt) => {
        if( opt.obj && opt.date && opt.date != '' ){
            const opts = {
                // Main DayJS object
                obj: opt.obj || false,

                // DateTime for compute
                date: opt.date || false,

                // Show Past or Future character
                sign: opt.sign || false,

                // View as momentjs short date format
                short: opt.short || false,

                // Show as full months, years, days ...
                as: opt.as || false,

                years: opt.years !== undefined ? opt.years : true,
                months: opt.months !== undefined ? opt.months : true,
                days: opt.days !== undefined ? opt.days : true,
                hours: opt.hours !== undefined ? opt.hours : true,
                minutes: opt.minutes !== undefined ? opt.minutes : true,
                seconds: opt.seconds !== undefined ? opt.seconds : true,
                milli: opt.milli !== undefined ? opt.milli : false
            };

            let dateobj = opts.obj;

            var diff=dateobj().diff(dateobj(opts.date)).valueOf(), sign=diff<0?-1:1, milliseconds,seconds,minutes,hours,days,months,years, result;
            diff/=sign; // or diff=Math.abs(diff);

            if( opts.short !== undefined && opts.short == true ){
                return dateobj(opts.date).fromNow();
            }

            let lang = dateobj.locale();
            let f1 = {};
            let f2 = dateobj.localeData(lang)._relativeTime;

            let sec = f2['ss'].split(' ');

            // f1['ss'] = '%d ' + sec[sec.length-1];
            f1['ms'] = '%d milli' + sec[sec.length-1];

            let ff = Object.assign(f1, f2);

            if( opts.as === undefined || opts.as === false )
            {
                [ff, years, months, days, hours, minutes, seconds, milliseconds] = _G.calcDateFormat(diff, ff, 'object');

                result = [
                    opts.years !== undefined && opts.years == true && !!years && ff['yy'],
                    opts.months !== undefined && opts.months == true && !!months && ff['MM'],
                    opts.days !== undefined && opts.days == true && !!days && ff['dd'],
                    opts.hours !== undefined && opts.hours == true && !!hours && ff['hh'],
                    opts.minutes !== undefined && opts.minutes == true && !!minutes && ff['mm'],
                    opts.seconds !== undefined && opts.seconds == true && !!seconds && ff['ss'],
                    opts.milli !== undefined && opts.milli == true && !!milliseconds && ff['ms']
                ]
                .filter(Boolean)
                .join(' ');
            }
            else if(opts.as && opts.as !== '')
            {
                [ff, years, months, days, hours, minutes, seconds, milliseconds] = _G.calcDateFormat(diff, ff, 'count');

                let f3 = {
                    'year': ff['yy'],
                    'month': ff['MM'],
                    'day': ff['dd'],
                    'hour': ff['hh'],
                    'minute': ff['mm'],
                    'second': ff['ss'],
                    'millisecond': ff['ms'],

                    'years': ff['yy'],
                    'months': ff['MM'],
                    'days': ff['dd'],
                    'hours': ff['hh'],
                    'minutes': ff['mm'],
                    'seconds': ff['ss'],
                    'milliseconds': ff['ms'],
                };

                result = f3[opts.as];
            }

            // dynamicFormats.length ? '' : '';
            return result + (opts.sign !== undefined && opts.sign == true ? (opts.sign && sign < 0 ? ff['future'] : ff['past']) : '');
            // return new Date(years, months, days, hours, minutes, seconds, milliseconds); //.format(dynamicFormats) +
                // (opts.sign !== undefined && opts.sign == true ? (opts.sign && sign < 0 ? ff['future'] : ff['past']) : '')
                // : '';
        }
        else
            return '';
    },

    getErrorMessages: (data) => {
        let m = [];
        if (typeof data === 'object')
            data.forEach((s) =>
                Object.keys(s).map((k) => { if (k != 'type') m.push(`${k} : ${s[k]}`); })
            )
        else m[0] = data;

        return m.join("<br />");
    },


    hasClientData: (name) => {
        if (typeof (Storage) !== 'undefined' && localStorage[name]) return true;
        else return false;
    },
    setClientData: async (name, value) => {
        if (typeof (Storage) !== 'undefined') {
            localStorage.setItem(name, value);
            return true;
        }
        else {
            return false;
            // Sorry! No Web Storage support..
        }
    },
    getClientData: (name) => {
        if (typeof (Storage) !== 'undefined' && localStorage[name]) {
            return localStorage.getItem(name);
        }
        else {
            return false;
            // Sorry! No Web Storage support..
        }
    },
    removeClientData: (name) => {
        if (typeof (Storage) !== 'undefined' && localStorage[name]) {
            localStorage.removeItem(name);
            return true;
        }
        else {
            return false;
            // Sorry! No Web Storage support..
        }
    },
    is_mobile: () => {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
            return true;//"Windows Phone";
        }

        if (/android|KFAPWI/i.test(userAgent)) {
            return true;//"Android";
        }

        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return true;//"iOS";
        }

        return false;
    },

    generateRandomSecurityKey: (min, max, codeNum) => {
        if( min == undefined ){
            min = 100;
        }
        if( max == undefined ){
            max = 999;
        }
        if( codeNum == undefined ){
            codeNum = 11;
        }
        let a = Math.floor(Math.random() * (max - min + 1) + min);
        let b = Math.floor(Math.random() * 9 + 1);
        let c = a << (b+codeNum);
        return `${c}${a}${b}`;
    },

    exf9: (str) => {
        str = str.toString();
        let size = 9;
        let es = [];
        let a = Math.floor(Math.random() * 9) + 11;
        for( let i=0; i < str.length; i++ ){
            let c = str[i].charCodeAt(0);
            let b = ((c << (a)) + 0).toString().padStart(size, '0');
            es.push( b );
        }
        return (a+14).toString().padStart(size, Math.random().toString().slice(2, (size - a.toString().length + 2)) ) + es.join('');
    },

    dxf9: (str) => {
        str = str.toString();
        let size = 9;
        let es = [];
        let b = Number(str.slice(size-2,size)) - 14;
        for( let i=size; i < str.length; i+=size ){
            let a = Number(str.slice(i, i+size).replace(/^[0]+/, '')) - 0 >> (b);
            es.push( String.fromCharCode( a ) );
        }
        return es.join('');
    },

    passString: {
        'A': 'oe',
        'B': 'wr',
        'C': 'bq',
        'D': 'a7',
        'E': 'm1',
        'F': 'mp',
        'G': 'v4',
        'H': 'u6',
        'I': 'xc',
        'J': '4p',
        'K': 'f8',
        'L': 'q2',
        'M': 'vn',
        'N': 'qt',
        'O': 'p5',
        'P': '3s',
        'Q': '%l',
        'R': 'w$',
        'S': 'a@',
        'T': '!&',
        'U': '(c',
        'V': 'vf',
        'W': 'p0',
        'X': '$-',
        'Y': 'v&',
        'Z': 'c*',
        'Ü': 'w#',
        'Ö': '%t',
        'Ğ': 'Fg',
        'İ': '@d',
        'Ə': 'Hn',
        'Ç': 'V^',
        'Ş': 'J*',
        '1': 'q@',
        '2': '02',
        '3': '.&',
        '4': 'w!',
        '5': '|q',
        '6': 'l|',
        '7': ')?',
        '8': '>s',
        '9': 's^',
        '0': ';&',
        'a': '$c',
        'b': '-g',
        'c': '|*',
        'd': '1-',
        'e': '>:',
        'f': '+x',
        'g': '^a',
        'h': ']E',
        'i': 'P0',
        'j': '{1',
        'k': 'cW',
        'l': 'Dc',
        'm': '*!',
        'n': 'W-',
        'o': '.?',
        'p': '%<',
        'q': ':a',
        'r': '&c',
        's': 'WY',
        't': '{h',
        'u': '_%',
        'v': '}$',
        'w': 'lU',
        'x': 'I^',
        'y': 'lP',
        'z': '.#',
        'ü': 'P(',
        'ö': ':)',
        'ğ': 'L_',
        'ı': 'I&',
        'ə': 'Y%',
        'ç': '{_',
        'ş': '>&',
        '!': '%-',
        '@': 'Y,',
        '#': '%B',
        '$': '*v',
        '%': ')T',
        '^': ';R',
        '&': 'G_',
        '*': '/e',
        '(': 'G%',
        ')': '*F',
        '_': '@*',
        '-': 'Hc',
        '=': '&D',
        '+': '(#',
        '[': 'lW',
        ']': ')Q',
        '{': 'D>',
        '}': '+%',
        ':': 's:',
        ';': '^(',
        ',': '&?',
        '.': 'G7',
        '<': 'K*',
        '>': 'L^',
        '/': '4C',
        '?': '#9',
        '|': '_@',
        ' ': '#B'
    },

    aEncrypt: (iStr, cryptCount) => {
        if (cryptCount === undefined) {
            cryptCount = 2;
        }
        iStr = iStr.toString();
        let o = '';
        if (iStr != '' && _G.passString != null) {
            for (var i = 0; i < cryptCount; i++) {
                for (var j = 0; j < iStr.length; j++) {
                    o += _G.passString[iStr.substring(j, j + 1)];
                }
                iStr = o;
                o = '';
            }
        }
        return iStr;
    },

    aDecrypt: (iStr, cryptCount) => {
        if (cryptCount === undefined) {
            cryptCount = 2;
        }
        iStr = iStr.toString();
        let o = '';
        if (iStr != '' && _G.passString != null) {
            for (var i = 0; i < cryptCount; i++) {
                for (var j = 0; j < iStr.length; j += 2) {
                    for(let a in _G.passString){
                        if (_G.passString[a] == iStr.substring(j, j + 2)) {
                            o += a;
                        }
                    }
                    // _G.passString.forEach((key, val) => {
                    //     if (val == iStr.substring(j, j + 2)) {
                    //         o += key;
                    //     }
                    // });
                }
                iStr = o;
                o = '';
            }
        }
        return iStr;
    },

    componentToHex: (c) => {
        var hex = c.toString(16);
        return hex.length == 1 ? "0" + hex : hex;
    },
    rgbToHex: (r, g, b) => {
        return "#" + _G.componentToHex(r) + _G.componentToHex(g) + _G.componentToHex(b);
    },
}